import { MissionAcceptanceFileType } from '@enums/mission-acceptance-file-type.enum';
import { HttpHelper } from '@helpers/http.helper';
import { PieceFile, PieceFileJson } from '@models/piece-file';
import { User, UserJson } from '@models/user';

export interface MissionAcceptanceFileJson extends PieceFileJson {
  title: string;
  type: MissionAcceptanceFileType;
  contact: Partial<UserJson>;
  created_by: Partial<UserJson>;
}

export class MissionAcceptanceFile extends PieceFile {
  constructor(
    id?: number,
    name?: string,
    mimeType?: string,
    createdAt?: string,
    public title?: string,
    public type?: MissionAcceptanceFileType,
    public contact?: User,
    public createdBy?: User,
    public contractId?: number
  ) {
    super(id, name, mimeType, createdAt);
  }

  static fromJson(json: Partial<MissionAcceptanceFileJson>): MissionAcceptanceFile {
    return new MissionAcceptanceFile(
      json.id,
      json.name,
      json.mime_type,
      json.created_at,
      json.title,
      json.type,
      json.contact ? User.fromJson(json.contact) : undefined,
      json.created_by ? User.fromJson(json.created_by) : undefined
    );
  }

  static toJson(file: MissionAcceptanceFile): Partial<MissionAcceptanceFileJson> {
    return {
      id: HttpHelper.toJsonProperty(file.id),
      title: HttpHelper.toJsonProperty(file.title),
      type: HttpHelper.toJsonProperty(file.type),
      contact: file.contact ? HttpHelper.toJsonId(file.contact) : undefined
    };
  }
}
